import React from 'react'
import moment from 'moment'

import {
    H5,
    Row,
    Col,
    Card,
    Table,
    Button,
    Divider,
    AddCard,
    MobileListCard,
    FormikInput,
    FormikSimpleSelect,
    FormikTextArea,
    FormikDate
} from '../../../Elements'
import { Icon } from '@blueprintjs/core'
import { FieldArray } from 'formik'
import { useMediaQuery } from 'react-responsive'
import _, { cloneDeep } from 'lodash'


const rightAlignTextStyle = {
    textAlign: 'right'
}

//#region guniteHistory

const MobileReadOnlyHistoryEntry = ({ historyEntry }) => (
    <>
        <p>{historyEntry.gunite_date ? moment(historyEntry.gunite_date).format('MM/DD/YYYY') : '(No Date)'}</p>
        <p>{historyEntry?.status?.name || '(No Status)'}</p>
        <p>{historyEntry?.crew?.name || '(No Crew)'}</p>
        <p>{historyEntry?.type?.name || '(No Type)'}</p>
        <p>{historyEntry?.yardage || '(No Yardage)'}</p>
        <p>{historyEntry?.job_order?.name || '(No Order)'}</p>
        <p style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{historyEntry?.notes || '(No Notes)'}</p>
    </>
)

const MobileEditHistoryEntry = ({ valuePrefix, idx, guniteHistoryTypes, jobOrders, crews, finishedDate, flashDate, scheduledDate, jobStatus,
    historyEntries, calculateNewTotalYardageFunction, calculateNewTotalFlashYardageFunction, calculateFinishedDateOnDateChangeFunction,
    calculateFlashDateOnDateChangeFunction, calculateFlashDateOnTypeChangeFunction,
    calculateScheduledDateOnDateChangeFunction, calculateScheduledDateOnTypeChangeFunction, jobStatuses, calculateGuniteDateOnStatusChange,
    calculateCrewOnStatusChange, calculateTypeOnStatusChange, calculateScheduledDateOnStatusChangeFunction, calculateSubJobStatusOnStatusChangeFunction,
    calculateFlashDateOnStatusChangeFunction, calculateFinishedDateOnStatusChangeFunction }) => (
    <Card>
        <FormikDate
            label='Date'
            key={`${valuePrefix}.gunite_details.gunite_history-${idx}-gunite_date`}
            name={`${valuePrefix}.gunite_details.gunite_history.${idx}.gunite_date`}
            listenerComponents={[
                {
                    componentName: `${valuePrefix}.gunite_details.finished_date`,
                    componentNewValueCalculator: (a, b, c) => calculateFinishedDateOnDateChangeFunction(a, b, c),
                    supportingProps: {
                        existingFinishedDate: finishedDate,
                        historyEntries: historyEntries,
                        indexChanged: idx
                    }
                },
                {
                    componentName: `${valuePrefix}.gunite_details.flash_date`,
                    componentNewValueCalculator: (a, b, c) => calculateFlashDateOnDateChangeFunction(a, b, c),
                    supportingProps: {
                        existingFlashDate: flashDate,
                        historyEntries: historyEntries,
                        indexChanged: idx
                    }
                },
                {
                    componentName: `${valuePrefix}.gunite_details.scheduled_date`,
                    componentNewValueCalculator: (a, b, c) => calculateScheduledDateOnDateChangeFunction(a, b, c),
                    supportingProps: {
                        existingScheduledDate: scheduledDate,
                        historyEntries: historyEntries,
                        indexChanged: idx
                    }
                }
            ]}
        />
        <FormikSimpleSelect
            label='Status'
            key={`${valuePrefix}.gunite_details.gunite_history-${idx}-status`}
            name={`${valuePrefix}.gunite_details.gunite_history.${idx}.status`}
            items={jobStatuses}
            nullable
            listenerComponents={[
                {
                    componentName: `${valuePrefix}.gunite_details.scheduled_date`,
                    componentNewValueCalculator: (a, b, c) => calculateScheduledDateOnStatusChangeFunction(a, b, c),
                    supportingProps: {
                        existingScheduledDate: scheduledDate,
                        historyEntries: historyEntries,
                        indexChanged: idx
                    }
                },
                {
                    componentName: `${valuePrefix}.gunite_details.flash_date`,
                    componentNewValueCalculator: (a, b, c) => calculateFlashDateOnStatusChangeFunction(a, b, c),
                    supportingProps: {
                        existingFlashDate: flashDate,
                        historyEntries: historyEntries,
                        indexChanged: idx
                    }
                },
                {
                    componentName: `${valuePrefix}.gunite_details.finished_date`,
                    componentNewValueCalculator: (a, b, c) => calculateFinishedDateOnStatusChangeFunction(a, b, c),
                    supportingProps: {
                        existingFinishedDate: finishedDate,
                        historyEntries: historyEntries,
                        indexChanged: idx
                    }
                },
                {
                    componentName: `${valuePrefix}.status`,
                    componentNewValueCalculator: (a, b, c) => calculateSubJobStatusOnStatusChangeFunction(a, b, c),
                    supportingProps: {
                        existingSubJobStatus: jobStatus,
                        historyEntries: historyEntries,
                        indexChanged: idx
                    }
                },
                {
                    componentName: `${valuePrefix}.gunite_details.gunite_history.${idx}.gunite_date`,
                    componentNewValueCalculator: (a, b, c) => calculateGuniteDateOnStatusChange(a, b, c),
                    supportingProps: { existingDateValue: historyEntries[idx].gunite_date }
                },
                {
                    componentName: `${valuePrefix}.gunite_details.gunite_history.${idx}.crew`,
                    componentNewValueCalculator: (a, b, c) => calculateCrewOnStatusChange(a, b, c),
                    supportingProps: { existingCrewValue: historyEntries[idx].crew }
                },
                {
                    componentName: `${valuePrefix}.gunite_details.gunite_history.${idx}.type`,
                    componentNewValueCalculator: (a, b, c) => calculateTypeOnStatusChange(a, b, c),
                    supportingProps: { existingTypeValue: historyEntries[idx].type }
                }
            ]}
        />
        <FormikSimpleSelect
            label='Crew'
            key={`${valuePrefix}.gunite_details.gunite_history-${idx}-crew`}
            name={`${valuePrefix}.gunite_details.gunite_history.${idx}.crew`}
            items={crews}
            nullable
        />
        <FormikSimpleSelect
            label='Type'
            key={`${valuePrefix}.gunite_details.gunite_history-${idx}-type`}
            name={`${valuePrefix}.gunite_details.gunite_history.${idx}.type`}
            items={guniteHistoryTypes}
            listenerComponents={[
                {
                    componentName: `${valuePrefix}.gunite_details.flash_date`,
                    componentNewValueCalculator: (a, b, c) => calculateFlashDateOnTypeChangeFunction(a, b, c),
                    supportingProps: {
                        existingFlashDate: flashDate,
                        historyEntries: historyEntries,
                        indexChanged: idx
                    }
                },
                {
                    componentName: `${valuePrefix}.gunite_details.scheduled_date`,
                    componentNewValueCalculator: (a, b, c) => calculateScheduledDateOnTypeChangeFunction(a, b, c),
                    supportingProps: {
                        existingScheduledDate: scheduledDate,
                        historyEntries: historyEntries,
                        indexChanged: idx
                    }
                }
            ]}
        />
        <FormikInput
            label='Yardage'
            key={`${valuePrefix}.gunite_details.gunite_history-${idx}-yardage`}
            name={`${valuePrefix}.gunite_details.gunite_history.${idx}.yardage`}
            placeholder='yardage...'
            type='number'
            listenerComponents={[
                { componentName: `${valuePrefix}.gunite_details.total_yardage`, componentNewValueCalculator: (a, b, c) => calculateNewTotalYardageFunction(a, b, c), supportingProps: { valueIndex: idx } },
                { componentName: `${valuePrefix}.gunite_details.flash_yards`, componentNewValueCalculator: (a, b, c) => calculateNewTotalFlashYardageFunction(a, b, c), supportingProps: { valueIndex: idx } },
            ]}
        />
        <FormikSimpleSelect
            label='Job Order'
            key={`${valuePrefix}.gunite_details.gunite_history-${idx}-job_order`}
            name={`${valuePrefix}.gunite_details.gunite_history.${idx}.job_order`}
            items={jobOrders}
            nullable
        />
        <FormikTextArea
            label='Notes'
            key={`${valuePrefix}.gunite_details.gunite_history-${idx}-notes`}
            name={`${valuePrefix}.gunite_details.gunite_history.${idx}.notes`}
            placeholder="notes..."
        />
    </Card>
)

export const GuniteHistoryRow = ({ values, valuePrefix, isMobile, crews, guniteHistoryTypes, jobOrders, jobStatuses, setFieldValue }) => {
    const defaultNewHistoryEntry = {
        id: -1,
        job_detail_id: values?.id || -1,
        type: null,
        job_order: null
    }

    const calculateNewTotalYardage = (_, inputValue, { valueIndex }) => {
        const parsedInput = inputValue ? parseInt(inputValue) : 0
        const parsedCurrentTotal = getCurrentTotal()

        if (isNaN(parsedInput) || isNaN(parsedCurrentTotal)) {
            return parsedCurrentTotal.toString()
        } else {
            const yardageTotal = calculateTotalYardage(valueIndex)

            const currentRecord = values.gunite_details.gunite_history[valueIndex]
            const returnValue = currentRecord?.type?.id === 9
                ? yardageTotal
                : yardageTotal + parsedInput

            return (returnValue).toString()
        }
    }

    const calculateNewTotalFlash = (_, inputValue, { valueIndex }) => {
        const parsedInput = inputValue ? parseInt(inputValue) : 0
        const parsedCurrentTotal = getCurrentTotal()

        if (isNaN(parsedInput) || isNaN(parsedCurrentTotal)) {
            return parsedCurrentTotal.toString()
        } else {
            const yardageTotal = calculateTotalFlash(valueIndex)
            const currentRecord = values.gunite_details.gunite_history[valueIndex]
            const returnValue = currentRecord && currentRecord.type && currentRecord.type.id === 9
                ? yardageTotal + parsedInput
                : yardageTotal

            return (returnValue).toString()
        }
    }

    const getCurrentTotal = () => values.gunite_details.total_yardage
        ? parseInt(values.gunite_details.total_yardage)
        : 0

    const calculateTotalFlash = (valueIndex) => {
        const parsedArray =
            values
                .gunite_details
                .gunite_history
                .filter((id, idx) => idx !== valueIndex)
                .filter(filterValue => filterValue && filterValue.type && filterValue.type.id === 9)
                .map(e => isNaN(parseInt(e.yardage)) ? 0 : parseInt(e.yardage))

        return parsedArray.reduce((acc, cur) => acc + cur, 0)
    }

    const calculateTotalYardage = (valueIndex) => {
        const parsedArray =
            values
                .gunite_details
                .gunite_history
                .filter((id, idx) => idx !== valueIndex)
                .filter(filterValue => !(filterValue && filterValue.type?.id === 9))
                .map(e => isNaN(parseInt(e.yardage)) ? 0 : parseInt(e.yardage))

        return parsedArray.reduce((acc, cur) => acc + cur, 0)
    }

    const calculateFlash = (_, inputValue, { valueIndex }) => {
        let total = 0;
        values.gunite_details.gunite_history.forEach((element, idx) => {
            if (idx === valueIndex) {
                if (inputValue && inputValue.id === 9) {
                    total += isNaN(parseInt(element.yardage)) ? 0 : parseInt(element.yardage)
                }
            } else {
                if (element.type?.id === 9) {
                    total += isNaN(parseInt(element.yardage)) ? 0 : parseInt(element.yardage)
                }
            }
        })
        return total
    }

    const calculateYardage = (_, inputValue, { valueIndex }) => {
        let total = 0;
        values.gunite_details.gunite_history.forEach((element, idx) => {
            if (idx === valueIndex) {
                if (inputValue && inputValue.id !== 9) {
                    total += isNaN(parseInt(element.yardage)) ? 0 : parseInt(element.yardage)
                }
            } else {
                if (element.type?.id !== 9) {
                    total += isNaN(parseInt(element.yardage)) ? 0 : parseInt(element.yardage)
                }
            }
        })
        return total
    }

    const APPLIED_STATUS_ID = 1
    const PENDING_STATUS_ID = 2

    const removeHistoryEntry = (removeFunction, valueIndex) => {
        const total_yardage = calculateTotalYardage(valueIndex)
        const total_flash = calculateTotalFlash(valueIndex)
        setFieldValue(`${valuePrefix}.gunite_details.total_yardage`, total_yardage)
        setFieldValue(`${valuePrefix}.gunite_details.flash_yards`, total_flash)

        const entriesWithTargetRemoved = values?.gunite_details?.gunite_history.filter((i, idx) => idx !== valueIndex)
        const newScheduledDate = calculateScheduledDate(entriesWithTargetRemoved)
        setFieldValue(`${valuePrefix}.gunite_details.scheduled_date`, newScheduledDate)
        const newFlashDate = calculateFlashDate(entriesWithTargetRemoved)
        setFieldValue(`${valuePrefix}.gunite_details.flash_date`, newFlashDate)
        const newFinishedDate = calculateFinishedDate(entriesWithTargetRemoved)
        setFieldValue(`${valuePrefix}.gunite_details.finished_date`, newFinishedDate)

        //if this removal causes the finished date to be null and the status was Applied
        //set the status to instead be Pending
        if (newFinishedDate === null && values?.status?.id === APPLIED_STATUS_ID) {
            setFieldValue(`${valuePrefix}.status`, jobStatuses.find(s => s.id === PENDING_STATUS_ID) || null)
        }

        removeFunction()
    }

    const addHistoryEntry = (formikPushFunction) => {
        const copiedEntriesWithNewDefaultEntry = [defaultNewHistoryEntry].concat(values.gunite_details.gunite_history)
        const newFinishedDate = calculateFinishedDate(copiedEntriesWithNewDefaultEntry)
        //expect that, based on current new entry default values,
        //this wil always cause the finished date to become null
        setFieldValue(`${valuePrefix}.gunite_details.finished_date`, newFinishedDate)
        
        if (newFinishedDate === null && values?.status?.id === APPLIED_STATUS_ID) {
            setFieldValue(`${valuePrefix}.status`, jobStatuses.find(s => s.id === PENDING_STATUS_ID) || null)
        }

        formikPushFunction()
    }

    //#region local helpers
    const isTypeIdDayOneThroughEight = (id) => [1, 2, 3, 4, 5, 6, 7, 8].includes(id)
    const isTypeIdFlash = (id) => id === 9
    const isStatusIdCancelled = (id) => id === 6
    const isStatusIdApplied = (id) => id === 1
    const isEveryEntryAppliedOrCancelled = (entries) => entries.every(e => isStatusIdApplied(e?.status?.id) || isStatusIdCancelled(e?.status?.id))
    //#endregion local helpers

    //#region scheduledDate
    const calculateScheduledDate = (historyEntries) => {
        //filter to only entries with Type of Day 1-8 or Flash that do NOT have the Cancelled Status
        const filtered = historyEntries?.filter(e => e?.type?.id
            && (isTypeIdDayOneThroughEight(e.type.id) || isTypeIdFlash(e.type.id))
            && e.status?.id !== 6
            && e.gunite_date
        )
        return _.minBy(filtered, (e) => e.gunite_date)?.gunite_date
    }

    const calculateScheduledDateOnDateChange = (_, newDateValue, { existingScheduledDate, historyEntries, indexChanged }) => {
        const copiedEntries = cloneDeep(historyEntries)
        const targetEntry = copiedEntries[indexChanged]

        const shouldRecalculateDate = !isStatusIdCancelled(targetEntry.status?.id) && (isTypeIdDayOneThroughEight(targetEntry.type?.id) || isTypeIdFlash(targetEntry.type?.id))
        //If date is being changed on a non-cancelled Entry of Type Day1-8 or Flash, set the Scheduled Date to the Earliest Day1-8 or Flash Entry date
        if (shouldRecalculateDate) {
            copiedEntries[indexChanged].gunite_date = newDateValue
            return calculateScheduledDate(copiedEntries)
        } else {
            //Otherwise, just leave the value as what it was
            return existingScheduledDate
        }
    }

    const calculateScheduledDateOnStatusChange = (_, newStatusValue, { existingScheduledDate, historyEntries, indexChanged }) => {
        const copiedEntries = cloneDeep(historyEntries)
        const targetEntry = copiedEntries[indexChanged]

        const shouldRecalculateDate = isStatusIdCancelled(targetEntry?.status?.id) || isStatusIdCancelled(newStatusValue?.id)
        //if Status is changing to or from Cancelled, then recalculate the Scheduled Date
        if (shouldRecalculateDate) {
            copiedEntries[indexChanged].status = newStatusValue
            return calculateScheduledDate(copiedEntries)
        } else {
            return existingScheduledDate
        }
    }

    const calculateScheduledDateOnTypeChange = (_, newTypeValue, { existingScheduledDate, historyEntries, indexChanged }) => {
        //If the status is changing from Type Day1-8 or Flash to non Day1-8/Flash
        const copiedEntries = cloneDeep(historyEntries)
        const targetEntry = copiedEntries[indexChanged]

        const shouldRecalculateDate = (isTypeIdDayOneThroughEight(targetEntry?.type?.id) || isTypeIdFlash(targetEntry?.type?.id)) !==
            (isTypeIdDayOneThroughEight(newTypeValue?.id) || isTypeIdFlash(newTypeValue?.id))
        //If type is changed to or from Day 1-8 or Flash, recalculate date
        if (shouldRecalculateDate) {
            copiedEntries[indexChanged].type = newTypeValue
            return calculateScheduledDate(copiedEntries)
        } else {
            return existingScheduledDate
        }
    }
    //#endregion scheduledDate

    //#region flashDate
    const calculateFlashDate = (historyEntries) => {
        //filter to only entries with Type Flash that do NOT have the Cancelled Status
        const filtered = historyEntries?.filter(e => e?.type?.id
            && isTypeIdFlash(e.type.id)
            && e.status?.id !== 6
            && e.gunite_date
        )
        return _.maxBy(filtered, (e) => e.gunite_date)?.gunite_date
    }

    const calculateFlashDateOnDateChange = (_, newDateValue, { existingFlashDate, historyEntries, indexChanged }) => {
        const copiedEntries = cloneDeep(historyEntries)
        const targetEntry = copiedEntries[indexChanged]

        const shouldRecalculateDate = !isStatusIdCancelled(targetEntry.status?.id) && (isTypeIdFlash(targetEntry.type?.id))
        //If date is being changed on a non-cancelled Entry of Type Flash, recalculate the Flash Date
        if (shouldRecalculateDate) {
            copiedEntries[indexChanged].gunite_date = newDateValue
            return calculateFlashDate(copiedEntries)
        } else {
            //Otherwise, just leave the value as what it was
            return existingFlashDate
        }
    }

    const calculateFlashDateOnStatusChange = (_, newStatusValue, { existingFlashDate, historyEntries, indexChanged }) => {
        const copiedEntries = cloneDeep(historyEntries)
        const targetEntry = copiedEntries[indexChanged]

        const shouldRecalculateDate = isTypeIdFlash(targetEntry?.type?.id) && (
            isStatusIdCancelled(targetEntry?.status?.id) !== isStatusIdCancelled(newStatusValue?.id)
        )
        //If Entry is of Type Flash AND is going to Cancelled from non-cancelled or to non-cancelled from cancelled, recalculate flash date
        if (shouldRecalculateDate) {
            copiedEntries[indexChanged].status = newStatusValue
            return calculateFlashDate(copiedEntries)
        } else {
            return existingFlashDate
        }
    }

    const calculateFlashDateOnTypeChange = (_, newTypeValue, { existingFlashDate, historyEntries, indexChanged }) => {
        const copiedEntries = cloneDeep(historyEntries)
        const targetEntry = copiedEntries[indexChanged]

        //if type was changed to or from Flash then recalculate the Flash date
        const shouldRecalculateDate = isTypeIdFlash(targetEntry?.type?.id) || isTypeIdFlash(newTypeValue?.id)

        if (shouldRecalculateDate) {
            copiedEntries[indexChanged].type = newTypeValue
            return calculateFlashDate(copiedEntries)
        } else {
            return existingFlashDate
        }
    }
    //#endregion flashDate

    //#region finishedDate
    const calculateFinishedDate = (historyEntries) => {
        //If All entries are of status 'Applied' or 'Cancelled', then the Finished 
        //Date should be the latest date from the 'Applied' Entries; else null
        const allEntriesAreAppliedOrCancelled = isEveryEntryAppliedOrCancelled(historyEntries)

        //filter to only entries with the 'Applied' status
        const filtered = historyEntries?.filter(e => isStatusIdApplied(e?.status?.id)
            && e.gunite_date
        )
        return allEntriesAreAppliedOrCancelled
            ? _.maxBy(filtered, (e) => e.gunite_date)?.gunite_date
            : null
    }

    const calculateFinishedDateOnDateChange = (_, newDateValue, { existingFinishedDate, historyEntries, indexChanged }) => {
        const copiedEntries = cloneDeep(historyEntries)
        const targetEntry = copiedEntries[indexChanged]

        //If Date was changed on an Applied Entry
        const shouldRecalculateDate = isStatusIdApplied(targetEntry?.status?.id)
        if (shouldRecalculateDate) {
            copiedEntries[indexChanged].gunite_date = newDateValue
            return calculateFinishedDate(copiedEntries)
        } else {
            //Otherwise, just leave the value as what it was
            return existingFinishedDate
        }
    }

    const calculateFinishedDateOnStatusChange = (_, newStatusValue, { existingFinishedDate, historyEntries, indexChanged }) => {
        const copiedEntries = cloneDeep(historyEntries)
        const targetEntry = copiedEntries[indexChanged]

        //If Status was changed to or from Applied/Cancelled
        const shouldRecalculateDate = isStatusIdApplied(targetEntry?.status?.id) || isStatusIdCancelled(targetEntry?.status?.id)
            || isStatusIdApplied(newStatusValue?.id) || isStatusIdCancelled(newStatusValue?.id)

        if (shouldRecalculateDate) {
            copiedEntries[indexChanged].status = newStatusValue
            return calculateFinishedDate(copiedEntries)
        } else {
            //Otherwise, just leave the value as what it was
            return existingFinishedDate
        }
    }
    //#endregion finishedDate

    //#region subJob-level Status
    const calculateSubJobStatusOnStatusChange = (_, newStatusValue, { existingSubJobStatus, historyEntries, indexChanged }) => {
        const copiedEntries = cloneDeep(historyEntries)
        //Set subjob status to pending if the status WAS applied but the new 
        //calculated Finished Date would be NULL
        copiedEntries[indexChanged].status = newStatusValue
        const shouldUpdateSubJobStatus = existingSubJobStatus?.id === APPLIED_STATUS_ID && calculateFinishedDate(copiedEntries) === null
        return shouldUpdateSubJobStatus
            ? jobStatuses.find(s => s.id === PENDING_STATUS_ID)
            : existingSubJobStatus
    }
    //#endregion subJob-level Status

    const calculateGuniteDateOnStatusChange = (_, newStatusValue, { existingDateValue }) => {
        return [3, 4, 6, 19].includes(newStatusValue?.id) //On Hold, Weeping (Cave In), Cancelled, Awaiting builder
            ? null
            : existingDateValue
    }

    const calculateCrewOnStatusChange = (_, newStatusValue, { existingCrewValue }) => {
        return [3, 4, 6, 19].includes(newStatusValue?.id) //On Hold, Weeping (Cave In), Cancelled, Awaiting builder
            ? null
            : existingCrewValue
    }

    const calculateTypeOnStatusChange = (_, newStatusValue, { existingTypeValue }) => {
        return [3, 4, 6, 19].includes(newStatusValue?.id) //On Hold, Weeping (Cave In), Cancelled, Awaiting builder
            ? guniteHistoryTypes.find(t => t.id === 1) ?? null //Day 1
            : existingTypeValue
    }

    const filteredJobStatuses = jobStatuses.filter(s => s.show_gunite_history)
    const indexOfStatusToNameMask = filteredJobStatuses.findIndex(s => s.id === 4) //Weeping is called 'Cave In' for Gunite
    if (indexOfStatusToNameMask > -1) {
        filteredJobStatuses[indexOfStatusToNameMask].name = 'Cave In'
    }
    filteredJobStatuses.sort((a, b) => a.name < b.name
        ? -1
        : a.name > b.name
            ? 1
            : 0)
    const smallScreenNonMobile = useMediaQuery({ query: '(max-width: 870px)' })
    return <Row>
        <Col lg={12}>
            <Divider style={{ marginBottom: '20px' }} />
            <H5>History</H5>
            <FieldArray
                name={`${valuePrefix}.gunite_details.gunite_history`}
                render={({ push, remove }) => (!isMobile
                    ? <Table
                        style={{ width: '100%' }}>
                        <thead>
                            <tr>
                                <th>
                                    Gunite Date
                                </th>
                                <th>
                                    Status
                                </th>
                                <th>
                                    Crew
                                </th>
                                <th>
                                    Type
                                </th>
                                <th>
                                    Yardage
                                </th>
                                <th>
                                    Job Order
                                </th>
                                <th>
                                    Notes
                                </th>
                                <th style={rightAlignTextStyle}>
                                    <Button icon='plus' intent='primary' text={smallScreenNonMobile ? '' : 'Add'} onClick={() => addHistoryEntry(() => push(defaultNewHistoryEntry))} />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {values.gunite_details.gunite_history && values.gunite_details.gunite_history.map((historyEntry, idx, self) => {
                                return (
                                    <tr key={`${valuePrefix}.gunite_details.gunite_history-${idx}`}>
                                        <td
                                            style={{
                                                minWidth: '12ch',
                                                maxWidth: '12ch',
                                                padding: smallScreenNonMobile ? 4 : 11
                                            }}
                                        >
                                            <FormikDate
                                                key={`gunite_date-${idx}-${historyEntry.gunite_date}`}
                                                name={`${valuePrefix}.gunite_details.gunite_history.${idx}.gunite_date`}
                                                listenerComponents={[
                                                    {
                                                        componentName: `${valuePrefix}.gunite_details.finished_date`,
                                                        componentNewValueCalculator: (a, b, c) => calculateFinishedDateOnDateChange(a, b, c),
                                                        supportingProps: {
                                                            existingFinishedDate: values.gunite_details.finished_date,
                                                            historyEntries: values.gunite_details.gunite_history,
                                                            indexChanged: idx
                                                        }
                                                    },
                                                    {
                                                        componentName: `${valuePrefix}.gunite_details.flash_date`,
                                                        componentNewValueCalculator: (a, b, c) => calculateFlashDateOnDateChange(a, b, c),
                                                        supportingProps: {
                                                            existingFlashDate: values.gunite_details.flash_date,
                                                            historyEntries: self,
                                                            indexChanged: idx
                                                        }
                                                    },
                                                    {
                                                        componentName: `${valuePrefix}.gunite_details.scheduled_date`,
                                                        componentNewValueCalculator: (a, b, c) => calculateScheduledDateOnDateChange(a, b, c),
                                                        supportingProps: {
                                                            existingScheduledDate: values.gunite_details.scheduled_date,
                                                            historyEntries: values.gunite_details.gunite_history,
                                                            indexChanged: idx
                                                        }
                                                    }
                                                ]}
                                            />
                                        </td>
                                        <td
                                            style={{
                                                minWidth: '11ch',
                                                padding: smallScreenNonMobile ? 4 : 11
                                            }}
                                        >
                                            <FormikSimpleSelect
                                                key={`crew-${idx}-${historyEntry.crew}`}
                                                name={`${valuePrefix}.gunite_details.gunite_history.${idx}.status`}
                                                items={filteredJobStatuses}
                                                nullable
                                                style={{
                                                    whiteSpace: 'normal',
                                                    height: 'fit-content',
                                                    minHeight: 30,
                                                    padding: '5px 25px 5px 10px'
                                                }}
                                                listenerComponents={[
                                                    {
                                                        componentName: `${valuePrefix}.gunite_details.scheduled_date`,
                                                        componentNewValueCalculator: (a, b, c) => calculateScheduledDateOnStatusChange(a, b, c),
                                                        supportingProps: {
                                                            existingScheduledDate: values.gunite_details.scheduled_date,
                                                            indexChanged: idx,
                                                            historyEntries: self
                                                        }
                                                    },
                                                    {
                                                        componentName: `${valuePrefix}.gunite_details.flash_date`,
                                                        componentNewValueCalculator: (a, b, c) => calculateFlashDateOnStatusChange(a, b, c),
                                                        supportingProps: {
                                                            existingFlashDate: values.gunite_details.flash_date,
                                                            historyEntries: self,
                                                            indexChanged: idx
                                                        }
                                                    },
                                                    {
                                                        componentName: `${valuePrefix}.gunite_details.finished_date`,
                                                        componentNewValueCalculator: (a, b, c) => calculateFinishedDateOnStatusChange(a, b, c),
                                                        supportingProps: {
                                                            existingFinishedDate: values.gunite_details.finished_date,
                                                            historyEntries: self,
                                                            indexChanged: idx
                                                        }
                                                    },
                                                    {
                                                        componentName: `${valuePrefix}.status`,
                                                        componentNewValueCalculator: (a, b, c) => calculateSubJobStatusOnStatusChange(a, b, c),
                                                        supportingProps: {
                                                            existingSubJobStatus: values.status,
                                                            historyEntries: self,
                                                            indexChanged: idx
                                                        }
                                                    },
                                                    {
                                                        componentName: `${valuePrefix}.gunite_details.gunite_history.${idx}.gunite_date`,
                                                        componentNewValueCalculator: (a, b, c) => calculateGuniteDateOnStatusChange(a, b, c),
                                                        supportingProps: { existingDateValue: historyEntry.gunite_date }
                                                    },
                                                    {
                                                        componentName: `${valuePrefix}.gunite_details.gunite_history.${idx}.crew`,
                                                        componentNewValueCalculator: (a, b, c) => calculateCrewOnStatusChange(a, b, c),
                                                        supportingProps: { existingCrewValue: historyEntry.crew }
                                                    },
                                                    {
                                                        componentName: `${valuePrefix}.gunite_details.gunite_history.${idx}.type`,
                                                        componentNewValueCalculator: (a, b, c) => calculateTypeOnStatusChange(a, b, c),
                                                        supportingProps: { existingTypeValue: historyEntry.type }
                                                    }
                                                ]}
                                            />
                                        </td>
                                        <td
                                            style={{
                                                minWidth: '11ch',
                                                padding: smallScreenNonMobile ? 4 : 11
                                            }}
                                        >
                                            <FormikSimpleSelect
                                                key={`crew-${idx}-${historyEntry.crew}`}
                                                name={`${valuePrefix}.gunite_details.gunite_history.${idx}.crew`}
                                                items={crews}
                                                nullable
                                                style={{
                                                    whiteSpace: 'normal',
                                                    height: 'fit-content',
                                                    minHeight: 30,
                                                    padding: '5px 25px 5px 10px'
                                                }}
                                            />
                                        </td>
                                        <td
                                            style={{
                                                minWidth: '12ch',
                                                padding: smallScreenNonMobile ? 4 : 11
                                            }}
                                        >
                                            <FormikSimpleSelect
                                                key={`${valuePrefix}.gunite_details.gunite_history-${idx}-type`}
                                                name={`${valuePrefix}.gunite_details.gunite_history.${idx}.type`}
                                                placeholder="type..."
                                                items={guniteHistoryTypes}
                                                nullable
                                                listenerComponents={[
                                                    {
                                                        componentName: `${valuePrefix}.gunite_details.total_yardage`,
                                                        componentNewValueCalculator: (a, b, c) => calculateYardage(a, b, c), supportingProps: { valueIndex: idx }
                                                    },
                                                    {
                                                        componentName: `${valuePrefix}.gunite_details.flash_yards`,
                                                        componentNewValueCalculator: (a, b, c) => calculateFlash(a, b, c), supportingProps: { valueIndex: idx }
                                                    },
                                                    {
                                                        componentName: `${valuePrefix}.gunite_details.flash_date`,
                                                        componentNewValueCalculator: (a, b, c) => calculateFlashDateOnTypeChange(a, b, c),
                                                        supportingProps: {
                                                            existingFlashDate: values.gunite_details.flash_date,
                                                            historyEntries: self,
                                                            indexChanged: idx
                                                        }
                                                    },
                                                    {
                                                        componentName: `${valuePrefix}.gunite_details.scheduled_date`,
                                                        componentNewValueCalculator: (a, b, c) => calculateScheduledDateOnTypeChange(a, b, c),
                                                        supportingProps: {
                                                            existingScheduledDate: values.gunite_details.scheduled_date,
                                                            historyEntries: self,
                                                            indexChanged: idx
                                                        }
                                                    }
                                                ]}
                                            />
                                        </td>
                                        <td
                                            style={{
                                                minWidth: '13ch',
                                                padding: smallScreenNonMobile ? 4 : 11
                                            }}
                                        >
                                            <FormikInput
                                                key={`yardage-${idx}-${historyEntry.yardage}`}
                                                name={`${valuePrefix}.gunite_details.gunite_history.${idx}.yardage`}
                                                placeholder='Yardage...'
                                                listenerComponents={[
                                                    { componentName: `${valuePrefix}.gunite_details.total_yardage`, componentNewValueCalculator: (a, b, c) => calculateNewTotalYardage(a, b, c), supportingProps: { valueIndex: idx } },
                                                    { componentName: `${valuePrefix}.gunite_details.flash_yards`, componentNewValueCalculator: (a, b, c) => calculateNewTotalFlash(a, b, c), supportingProps: { valueIndex: idx } }
                                                ]}
                                            />
                                        </td>
                                        <td
                                            style={{
                                                minWidth: '8ch',
                                                padding: smallScreenNonMobile ? 4 : 11
                                            }}
                                        >
                                            <FormikSimpleSelect
                                                key={`${valuePrefix}.gunite_details.gunite_history-${idx}-job_order`}
                                                name={`${valuePrefix}.gunite_details.gunite_history.${idx}.job_order`}
                                                placeholder="job order..."
                                                items={jobOrders}
                                                nullable
                                            />
                                        </td>
                                        <td
                                            style={{
                                                padding: smallScreenNonMobile ? 4 : 11
                                            }}
                                        >
                                            <FormikTextArea
                                                key={`notes-${idx}-${historyEntry.notes}`}
                                                name={`${valuePrefix}.gunite_details.gunite_history.${idx}.notes`}
                                                placeholder="notes..."
                                                onKeyDown={(e) => {
                                                    if (e.key.toLowerCase() === 'tab' || e.keyCode === 9) {
                                                        // verify TextArea on last entry
                                                        if (values.gunite_details.gunite_history.length - 1 === idx) {
                                                            addHistoryEntry(() => push(defaultNewHistoryEntry))
                                                        }
                                                    }
                                                }}
                                            />
                                        </td>
                                        <td style={rightAlignTextStyle}>
                                            <Icon icon='delete' iconSize='25' intent='danger' onClick={() => removeHistoryEntry(() => remove(idx), idx)} />
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                    : <Row>
                        {values.gunite_details.gunite_history && values.gunite_details.gunite_history.map((historyEntry, idx, ar) => {
                            return (
                                <Col xs={6}>
                                    <MobileListCard
                                        idx={idx}
                                        onRemove={() => removeHistoryEntry(() => remove(idx), idx)}
                                        dialogTitle='History Entry'
                                        autoOpen={(historyEntry.createdOnMobile && ((ar.length - 1) === idx) && (historyEntry.id === -1))}
                                        readOnlyContent={<MobileReadOnlyHistoryEntry historyEntry={historyEntry} />}
                                        editViewContent={<MobileEditHistoryEntry idx={idx} valuePrefix={valuePrefix} guniteHistoryTypes={guniteHistoryTypes} jobOrders={jobOrders} crews={crews}
                                            finishedDate={values.gunite_details?.finished_date} flashDate={values.gunite_details?.flash_date} jobStatus={values.status} scheduledDate={values.gunite_details?.scheduled_date}
                                            historyEntries={values.gunite_details?.gunite_history}
                                            jobStatuses={filteredJobStatuses}
                                            calculateNewTotalYardageFunction={(a, b, c) => calculateNewTotalYardage(a, b, c)}
                                            calculateNewTotalFlashYardageFunction={(a, b, c) => calculateNewTotalFlash(a, b, c)}
                                            calculateFinishedDateOnDateChangeFunction={(a, b, c) => calculateFinishedDateOnDateChange(a, b, c)}
                                            calculateFlashDateOnDateChangeFunction={(a, b, c) => calculateFlashDateOnDateChange(a, b, c)}
                                            calculateFlashDateOnTypeChangeFunction={(a, b, c) => calculateFlashDateOnTypeChange(a, b, c)}
                                            calculateScheduledDateOnDateChangeFunction={(a, b, c) => calculateScheduledDateOnDateChange(a, b, c)}
                                            calculateScheduledDateOnTypeChangeFunction={(a, b, c) => calculateScheduledDateOnTypeChange(a, b, c)}
                                            calculateGuniteDateOnStatusChange={(a, b, c) => calculateGuniteDateOnStatusChange(a, b, c)}
                                            calculateCrewOnStatusChange={(a, b, c) => calculateCrewOnStatusChange(a, b, c)}
                                            calculateTypeOnStatusChange={(a, b, c) => calculateTypeOnStatusChange(a, b, c)}
                                            calculateScheduledDateOnStatusChangeFunction={(a, b, c) => calculateScheduledDateOnStatusChange(a, b, c)}
                                            calculateFlashDateOnStatusChangeFunction={(a, b, c) => calculateFlashDateOnStatusChange(a, b, c)}
                                            calculateFinishedDateOnStatusChangeFunction={(a, b, c) => calculateFinishedDateOnStatusChange(a, b, c)}
                                            calculateSubJobStatusOnStatusChangeFunction={(a, b, c) => calculateSubJobStatusOnStatusChange(a, b, c)}
                                        />}
                                    />
                                </Col>
                            )
                        })}
                        <Col xs={6}>
                            <AddCard onClick={() => addHistoryEntry(() => push({ ...defaultNewHistoryEntry, createdOnMobile: true }))} />
                        </Col>
                    </Row>
                )}
            />
        </Col>
    </Row>
}

//#endregion guniteHistory